import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableInvestigationActivityFragment = { readonly __typename?: 'SyncableInvestigationActivity', readonly id: string, readonly patientId: string, readonly catalogueItem: { readonly __typename?: 'SyncableInvestigationCatalogueItem', readonly activityType: string, readonly version: number, readonly id: string, readonly meta?: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string } | null, readonly coding?: { readonly __typename?: 'CatalogueCoding', readonly elephant?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null, readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null } | null, readonly keywords?: ReadonlyArray<{ readonly __typename?: 'I18nString', readonly en: string } | null> | null, readonly result?: { readonly __typename?: 'InvestigationItemResult', readonly resultSchema: unknown } | null, readonly title: { readonly __typename?: 'I18nString', readonly en: string } }, readonly clinicalEvent?: { readonly __typename?: 'ClinicalEvent', readonly id: string, readonly type: Types.ClinicalEventType } | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string }, readonly outcome?: { readonly __typename?: 'SyncableInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly clinic: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly organisation: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly performer: { readonly __typename?: 'SyncableElephantActor', readonly id: string, readonly name: string } } | null, readonly request: { readonly __typename?: 'SyncableInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly clinic: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly organisation: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly performer: { readonly __typename?: 'SyncableElephantActor', readonly id: string, readonly name: string } } };

export type InvestigationActivityPushMutationVariables = Types.Exact<{
  input: Types.PushInvestigationActivityInput;
}>;


export type InvestigationActivityPushMutation = { readonly __typename?: 'Mutation', readonly pushInvestigationActivity: { readonly __typename?: 'PushInvestigationActivityResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableInvestigationActivity', readonly id: string, readonly patientId: string, readonly catalogueItem: { readonly __typename?: 'SyncableInvestigationCatalogueItem', readonly activityType: string, readonly version: number, readonly id: string, readonly meta?: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string } | null, readonly coding?: { readonly __typename?: 'CatalogueCoding', readonly elephant?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null, readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null } | null, readonly keywords?: ReadonlyArray<{ readonly __typename?: 'I18nString', readonly en: string } | null> | null, readonly result?: { readonly __typename?: 'InvestigationItemResult', readonly resultSchema: unknown } | null, readonly title: { readonly __typename?: 'I18nString', readonly en: string } }, readonly clinicalEvent?: { readonly __typename?: 'ClinicalEvent', readonly id: string, readonly type: Types.ClinicalEventType } | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string }, readonly outcome?: { readonly __typename?: 'SyncableInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly clinic: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly organisation: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly performer: { readonly __typename?: 'SyncableElephantActor', readonly id: string, readonly name: string } } | null, readonly request: { readonly __typename?: 'SyncableInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly clinic: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly organisation: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly performer: { readonly __typename?: 'SyncableElephantActor', readonly id: string, readonly name: string } } }> } };

export type InvestigationActivityPullQueryVariables = Types.Exact<{
  input: Types.PullInvestigationActivityInput;
}>;


export type InvestigationActivityPullQuery = { readonly __typename?: 'Query', readonly pullInvestigationActivity: { readonly __typename?: 'PullInvestigationActivityResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableInvestigationActivity', readonly id: string, readonly patientId: string, readonly catalogueItem: { readonly __typename?: 'SyncableInvestigationCatalogueItem', readonly activityType: string, readonly version: number, readonly id: string, readonly meta?: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string } | null, readonly coding?: { readonly __typename?: 'CatalogueCoding', readonly elephant?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null, readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null } | null, readonly keywords?: ReadonlyArray<{ readonly __typename?: 'I18nString', readonly en: string } | null> | null, readonly result?: { readonly __typename?: 'InvestigationItemResult', readonly resultSchema: unknown } | null, readonly title: { readonly __typename?: 'I18nString', readonly en: string } }, readonly clinicalEvent?: { readonly __typename?: 'ClinicalEvent', readonly id: string, readonly type: Types.ClinicalEventType } | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string }, readonly outcome?: { readonly __typename?: 'SyncableInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly clinic: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly organisation: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly performer: { readonly __typename?: 'SyncableElephantActor', readonly id: string, readonly name: string } } | null, readonly request: { readonly __typename?: 'SyncableInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly clinic: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly organisation: { readonly __typename?: 'SyncableFacilitySnapshot', readonly id: string, readonly name: string }, readonly performer: { readonly __typename?: 'SyncableElephantActor', readonly id: string, readonly name: string } } }> } };

export const WholeSyncableInvestigationActivityFragmentDoc = gql`
    fragment WholeSyncableInvestigationActivity on SyncableInvestigationActivity {
  id
  patientId
  catalogueItem {
    meta {
      deleted
      updatedAt
      createdAt
      updatedByUserId
      createdByUserId
    }
    activityType
    coding {
      elephant {
        code
        display
        system
      }
      loinc {
        code
        display
        system
      }
    }
    version
    id
    keywords {
      en
    }
    result {
      resultSchema
    }
    title {
      en
    }
  }
  clinicalEvent {
    id
    type
  }
  meta {
    deleted
    updatedAt
    createdAt
    updatedByUserId
    createdByUserId
  }
  outcome {
    clinic {
      id
      name
    }
    meta {
      created
      updated
    }
    orderedProperties
    organisation {
      id
      name
    }
    performer {
      id
      name
    }
  }
  request {
    clinic {
      id
      name
    }
    meta {
      created
      updated
    }
    orderedProperties
    organisation {
      id
      name
    }
    performer {
      id
      name
    }
  }
}
    `;
export const InvestigationActivityPushDocument = gql`
    mutation InvestigationActivityPush($input: PushInvestigationActivityInput!) {
  pushInvestigationActivity(input: $input) {
    rows {
      ...WholeSyncableInvestigationActivity
    }
  }
}
    ${WholeSyncableInvestigationActivityFragmentDoc}`;
export type InvestigationActivityPushMutationFn = Apollo.MutationFunction<InvestigationActivityPushMutation, InvestigationActivityPushMutationVariables>;

/**
 * __useInvestigationActivityPushMutation__
 *
 * To run a mutation, you first call `useInvestigationActivityPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestigationActivityPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investigationActivityPushMutation, { data, loading, error }] = useInvestigationActivityPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestigationActivityPushMutation(baseOptions?: Apollo.MutationHookOptions<InvestigationActivityPushMutation, InvestigationActivityPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvestigationActivityPushMutation, InvestigationActivityPushMutationVariables>(InvestigationActivityPushDocument, options);
      }
export type InvestigationActivityPushMutationHookResult = ReturnType<typeof useInvestigationActivityPushMutation>;
export type InvestigationActivityPushMutationResult = Apollo.MutationResult<InvestigationActivityPushMutation>;
export type InvestigationActivityPushMutationOptions = Apollo.BaseMutationOptions<InvestigationActivityPushMutation, InvestigationActivityPushMutationVariables>;
export const InvestigationActivityPullDocument = gql`
    query InvestigationActivityPull($input: PullInvestigationActivityInput!) {
  pullInvestigationActivity(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableInvestigationActivity
    }
  }
}
    ${WholeSyncableInvestigationActivityFragmentDoc}`;

/**
 * __useInvestigationActivityPullQuery__
 *
 * To run a query within a React component, call `useInvestigationActivityPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestigationActivityPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestigationActivityPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestigationActivityPullQuery(baseOptions: Apollo.QueryHookOptions<InvestigationActivityPullQuery, InvestigationActivityPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestigationActivityPullQuery, InvestigationActivityPullQueryVariables>(InvestigationActivityPullDocument, options);
      }
export function useInvestigationActivityPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestigationActivityPullQuery, InvestigationActivityPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestigationActivityPullQuery, InvestigationActivityPullQueryVariables>(InvestigationActivityPullDocument, options);
        }
export type InvestigationActivityPullQueryHookResult = ReturnType<typeof useInvestigationActivityPullQuery>;
export type InvestigationActivityPullLazyQueryHookResult = ReturnType<typeof useInvestigationActivityPullLazyQuery>;
export type InvestigationActivityPullQueryResult = Apollo.QueryResult<InvestigationActivityPullQuery, InvestigationActivityPullQueryVariables>;